require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-meet-dave-parker-the-new-ceo-of-code-fellows.json") })
        }
      }, "path---blog-meet-dave-parker-the-new-ceo-of-code-fellows");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-meet-dave-parker-the-new-ceo-of-code-fellows!./.cache/json/blog-meet-dave-parker-the-new-ceo-of-code-fellows.json
// module id = 942
// module chunks = 231608221292675